/**
 * Tier 1 WhatsApp-native delivery/engagement filter. Values must match the
 * backend's `ADVANCED_FILTER_KEYS` in `contact-filter.service.ts` exactly —
 * shared verbatim between the Contacts page's filter drawer and Campaign
 * targeting's "Custom segment" builder so both stay wired to the same
 * single, already-tested resolver (`buildAdvancedFilterQuery`) instead of
 * drifting into two definitions of the same seven keys.
 */
export const ADVANCED_FILTER_OPTIONS = [
  { value: 'all', label: 'No advanced filter' },
  { value: 'active24h', label: 'Active 24h window' },
  { value: 'replied', label: 'Replied to campaign' },
  { value: 'readNotReplied', label: 'Read · not replied' },
  { value: 'deliveredNotRead', label: 'Delivered · not read' },
  // "Never targeted" (zero campaign history) vs. "Targeted but never delivered"
  // (all attempts failed) are DIFFERENT populations. The older labels called the
  // second one "Never delivered — …", which read like the first and caused real
  // confusion (a tenant expecting their whole un-messaged audience got only the
  // small all-failed suppression set). Labels now name the axis precisely.
  { value: 'neverTargetedAnyCampaign', label: 'Never targeted — no campaign yet' },
  { value: 'neverDeliveredThisCampaign', label: 'Targeted, never delivered — this campaign' },
  {
    value: 'neverDeliveredAnyCampaign',
    label: 'Targeted, never delivered — any campaign (suppression)',
  },
  { value: 'failedByError', label: 'Failed by error code' },
] as const;
